import { useState, useCallback } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { PersonalInfoSection, PersonalInfoData } from "@/components/sections/PersonalInfoSection";
import { authLabels, commonButtonLabels } from "@/i18n";

interface ConsumerRegistrationFormProps {
  onBack: () => void;
  onSubmit: (data: any) => void;
  isLoading?: boolean;
  error?: string;
  nameFromBankId?: boolean;
}

const initialPersonalInfo: PersonalInfoData = {
  username: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
};

const ConsumerRegistrationForm = ({
  onBack,
  onSubmit,
  isLoading = false,
  error,
  nameFromBankId = false,
}: ConsumerRegistrationFormProps) => {
  const authLabels_i18n = authLabels();
  const buttonLabels = commonButtonLabels();
  
  const [personalInfo, setPersonalInfo] = useState(initialPersonalInfo);
  const [personalValid, setPersonalValid] = useState(false);

  const handlePersonalChange = useCallback((data: PersonalInfoData, valid: boolean) => {
    setPersonalInfo(data);
    setPersonalValid(valid);
  }, []);

  const handleSubmit = () => {
    if (!personalValid) {
      alert(authLabels_i18n.forms.validation.fillAllFieldsPersonalInfo);
      return;
    }
    onSubmit({
      ...personalInfo,
      type: "consumer"
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h3 className="text-lg font-semibold">{authLabels_i18n.forms.registerConsumer}</h3>
      </div>

      <PersonalInfoSection
        value={personalInfo}
        onChange={handlePersonalChange}
        nameFromBankId={nameFromBankId}
      />

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
          <p className="text-sm">{error}</p>
        </div>
      )}

      <div className="flex justify-end gap-3 pt-4">
        <Button variant="outline" onClick={onBack} disabled={isLoading}>
          {buttonLabels.cancel}
        </Button>
        <Button onClick={handleSubmit} disabled={!personalValid || isLoading} >
          {isLoading ? authLabels_i18n.buttons.creatingAccount : authLabels_i18n.buttons.createAccount}
        </Button>
      </div>
    </div>
  );
};

export default ConsumerRegistrationForm;
